import { useQuery } from '@tanstack/react-query';
import { api } from '../client';
import type { ApiProject } from '../types';
import i18n from '../../../i18n';

interface UseProjectsOptions {
    featured?: boolean;
    areaId?: string;
    page?: number;
    limit?: number;
    enabled?: boolean;
    ids?: string[];
}

export function useProjects(options: UseProjectsOptions = {}) {
    const { featured, areaId, page = 1, limit = 20, enabled = true, ids } = options;

    const params = new URLSearchParams();
    params.set('page', String(page));
    params.set('limit', String(limit));
    if (featured) params.set('featured', 'true');
    if (areaId) params.set('areaId', areaId);
    if (ids && ids.length > 0) params.set('ids', ids.join(','));

    return useQuery({
        queryKey: ['projects', { featured, areaId, page, limit, ids, locale: i18n.language }],
        queryFn: async () => {
            const { data } = await api.get<ApiProject[]>(`/api/projects?${params.toString()}`);
            return data || [];
        },
        enabled,
    });
}

export function useProject(slug: string | undefined) {
    return useQuery({
        queryKey: ['project', slug, i18n.language],
        queryFn: async () => {
            const res = await api.get<ApiProject>(`/api/projects/${slug}`);
            return res.data!;
        },
        enabled: !!slug,
    });
}
